module.exports = __webpack_public_path__ + "static/media/instagram.916b868f.png";